import React from "react";
import { number, bool, string } from "prop-types";
import { cx } from "@livechat/ui-kit";
import I18n from "pages/_components/I18n";

const ComexStepper = ({ isDesktop, currentStep, totalStep, i18nTextValue, type }) => {
    const defaultColor = "var(--primary-background-color)";
    const activeColor = "var(--details-details-color)";
    return (
        <div className="stepper">
            <div className={cx("step-comex", { desktop: isDesktop })}>
                {[...Array(totalStep)].map((_, index) => (
                    <div
                        key={`step-bar-${index + 1}`}
                        style={{
                            width: `${100 / totalStep}%`,
                            borderRadius: 6,
                            height: 6,
                            marginBottom: 10,
                            backgroundColor: index < currentStep ? activeColor : defaultColor,
                        }}
                    />
                ))}
            </div>
            <div className={cx("step-detail", { desktop: isDesktop })}>
                <I18n id={i18nTextValue || `comex.transfer.step${currentStep}${type ? "." + type : ""}`} defaultValue=" " component="span" />
            </div>
        </div>
    );
};
ComexStepper.defaultProps = {
    i18nTextValue: null,
    totalStep: 9,
};

ComexStepper.propTypes = {
    isDesktop: bool.isRequired,
    currentStep: number.isRequired,
    totalStep: number,
    i18nTextValue: string,
};

export default ComexStepper;
